import React, { useState, useEffect } from "react";
import { getData, postData } from "../components/helpers/Data";
import MessageModal from "../components/helpers/Modal2";
import { userSaveDetails } from "../components/helpers/UserSaveDetails";

const CustomerRegistration = () => {
  //create array for logs when renewing corp
  const logData = userSaveDetails(9);

  //module variables
  const [users, setUsers] = useState([]);
  const [messageModal, setIsMessageModal] = useState(false);
  const [response, setResponse] = useState(false);

  const saveCustomer = (e) => {
    e.preventDefault();
    const frmData = new FormData(document.getElementById("customerFrm"));

    //append access log details
    frmData.append("user_id", logData[0]);
    frmData.append("accessed_item", logData[1]);
    frmData.append("browser_type", logData[2]);
    frmData.append("os_type", logData[3]);

    postData(frmData, "save_customer")
      .then((data) => {
        if (data.includes('Error')) {
          setResponse('Error adding customer!');          
        }else{
          setResponse(data);
        }
        setIsMessageModal(true);
      })
      .catch((error) => {
        console.log(error);
        alert('Error saving customer, contact admin!')
      });
  };
  //close message modal
  const closeMessageModal = () => {
    setIsMessageModal(false);
    if (response.includes("successfully")) {
      window.location.replace("/change-password");
    }
  };
  return (
    <div>
      <section id="changepassword">
        <div className="row">
          <div className="col-md-12">
            <form
              className="claims_form mt-1"
              id="customerFrm"
              onSubmit={saveCustomer}
            >
              <div style={{ textAlign: "left" }} className="row gap-3">
                <div>
                  <label for="names">NAMES</label>
                  <input
                    className="form-control"
                    placeholder="names e.g john doe"
                    type="text"
                    name="names"
                  />
                </div>
                <div>
                  <label for="names">PHONE NO</label>
                  <input
                    className="form-control"
                    placeholder="e.g 0723423434"
                    type="text"
                    name="phone_no"
                  />
                </div>
                <div>
                  <label for="names">ID NO</label>
                  <input
                    className="form-control"
                    placeholder="id no e.g 12345"
                    type="text"
                    name="id_no"
                  />
                </div>
                <div>
                  <label for="names">DOB</label>
                  <input
                    className="form-control"
                    placeholder="dob"
                    type="date"
                    name="dob"
                  />
                </div>

                <p>
                  <input
                    type="submit"
                    className="btn-success col-4"
                    value="Save"
                  />
                </p>
              </div>
            </form>
          </div>
        </div>
      </section>
      {/*Message modal*/}
      <MessageModal
        modalIsOpen={messageModal}
        closeModal={closeMessageModal}
        background="#0047AB"
        body={<p className="text-white font-weight-bold h4">{response}</p>}
      />
    </div>
  );
};

export default CustomerRegistration;
